import React from 'react';
import { FIRMWARE_CHANNELS } from '../../../api/firmware';
import { channelClass, firmwareChannels, formatBytes } from '../firmwareUtils';

export default function FirmwarePackagesTab({
  packages,
  filteredPackages,
  packageSearch,
  packageChannel,
  packagesLoading,
  packagesError,
  packagesNextToken,
  activeRollouts,
  canUpload,
  canRemove,
  canRelease,
  onPackageSearchChange,
  onPackageChannelChange,
  onResetFilters,
  onLoadMore,
  onRetryChannels,
  onOpenUpload,
  onViewPackage,
  onPromotePackage,
  onOpenGroups,
  onRemovePackage,
}) {
  const channelsUnavailable = packages.some((firmware) => firmware.promotionsError);
  return (
    <section className="firmware-view">
      <div className="firmware-toolbar">
        <div className="firmware-toolbar-title"><h3>Firmware Packages</h3><span>{packages.length} packages</span></div>
        <div className="firmware-toolbar-actions">
          <button type="button" className="btn btn-secondary" onClick={onResetFilters}>Reset filters</button>
          {canRelease ? <button type="button" className="btn btn-secondary" onClick={onOpenGroups}>Firmware groups</button> : null}
          {canUpload ? <button type="button" className="btn btn-primary" onClick={onOpenUpload}>Upload firmware</button> : null}
        </div>
      </div>

      <div className="firmware-summary-grid">
        <div><span>Production packages</span><strong>{channelsUnavailable ? 'N/A' : packages.filter((item) => firmwareChannels(item).includes('PRODUCTION')).length}</strong></div>
        <div><span>Release review</span><strong>{channelsUnavailable ? 'N/A' : packages.filter((item) => firmwareChannels(item).includes('INTERNAL')).length}</strong></div>
        <div><span>Beta packages</span><strong>{channelsUnavailable ? 'N/A' : packages.filter((item) => firmwareChannels(item).includes('BETA')).length}</strong></div>
        <div><span>Active rollouts</span><strong>{activeRollouts}</strong></div>
      </div>

      <div className="firmware-filters">
        <label className="firmware-search"><span>Search</span><input value={packageSearch} onChange={(event) => onPackageSearchChange(event.target.value)} placeholder="Version, package ID, model, hardware" /></label>
        <label><span>Channel</span><select value={packageChannel} onChange={(event) => onPackageChannelChange(event.target.value)}><option value="ALL">All channels</option>{FIRMWARE_CHANNELS.map((channel) => <option key={channel} value={channel}>{channel}</option>)}</select></label>
      </div>

      <div className="firmware-table-wrap">
        {packagesError ? <div className="alert alert-error" role="alert">{packagesError}</div> : null}
        {channelsUnavailable ? <div className="alert alert-error" role="alert">Some firmware channels could not be loaded. Channel filters and counts may be incomplete. <button type="button" className="firmware-text-button" onClick={onRetryChannels} disabled={packagesLoading}>Retry channels</button></div> : null}
        <table className="firmware-table">
          <thead><tr><th>Package</th><th>Version</th><th>Channels</th><th>Size</th><th>Released</th><th aria-label="Actions" /></tr></thead>
          <tbody>
            {filteredPackages.map((firmware) => (
              <tr key={firmware.id}>
                <td><strong>{firmware.deviceModel}</strong><span>{firmware.hardwareVersion}</span></td>
                <td><button type="button" className="firmware-link" onClick={() => onViewPackage(firmware)}>{firmware.firmwareVersion}</button><span>{firmware.id}</span></td>
                <td><div className="fw-package-channels">{firmware.promotionsError ? <span>Channels unavailable</span> : firmwareChannels(firmware).length ? firmwareChannels(firmware).map((channel) => <span key={channel} className={channelClass(channel)}>{channel}</span>) : <span>Not promoted</span>}</div></td>
                <td>{formatBytes(firmware.sizeInBytes)}</td>
                <td>{firmware.releaseDate}</td>
                <td className="firmware-row-actions">
                  <button type="button" className="firmware-text-button" onClick={() => onViewPackage(firmware)}>View</button>
                  {canRelease ? <button type="button" className="firmware-text-button" onClick={() => onPromotePackage(firmware)}>Promote</button> : null}
                  {canRemove ? <button type="button" className="firmware-text-button firmware-text-danger" onClick={() => onRemovePackage(firmware)}>Remove</button> : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {packagesLoading ? <div className="firmware-empty">Loading firmware packages...</div> : null}
        {!packagesLoading && !filteredPackages.length ? <div className="firmware-empty">No firmware packages match the current filters.</div> : null}
        {packagesNextToken ? <div className="firmware-load-more"><button type="button" className="btn btn-secondary" onClick={onLoadMore} disabled={packagesLoading}>Load more</button></div> : null}
      </div>
    </section>
  );
}
